<form *ngIf="!complete && showKaskoversicherung() || complete && interesseKaskoversicherung" [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective" autocomplete="off">
  <div class="kfz-paket-description" *ngIf="showKaskoversicherungInfo && (translateService.get(motorrad ? 'KASKOVERSICHERUNGINFOMOTORRAD' : 'KASKOVERSICHERUNGINFO', { vollKaskoInfoTexts : vollKaskoInfoTexts }) | async) as res" [innerHTML]="res"></div>
  <div class="kfz-paket-body">
    <div class="header mb-3" *ngIf="showHeader" [ngClass]="{'kfz-paket-sub-container' : kaskoIndex > 0}">
      <strong>Fahrzeug {{ kaskoIndex + 1 }} ({{ risikoKfzComponent.marke.value?.Value }} {{ risikoKfzComponent.modell.value }})</strong>
    </div>
    <div class="kfz-paket-selection">
      <div *ngIf="complete; else _kaskoVariante">
        <div class="input">
          <label class="input__label" [for]="idprefix + '_versicherungsart_' + kaskoIndex">Versicherungsart:</label>
          <mat-form-field>
            <input matInput [id]="idprefix + '_versicherungsart_' + kaskoIndex" [value]="versicherungsart" disabled>
          </mat-form-field>
        </div>
      </div>
      <ng-template #_kaskoVariante>
        <div>
          <app-label [control]="kaskoVariante" [for]="idprefix + '_kaskoVariante_' + kaskoIndex">{{ expertMode ? 'Kaskoversicherung' : motorrad ? 'Wünschen Sie zusätzlich eine Motorrad-Kaskoversicherung?' : 'Wünschen Sie zusätzlich eine Kaskoversicherung?' }}</app-label>
          <mat-radio-group class="vertical-radio-group" [id]="idprefix + '_kaskoVariante_' + kaskoIndex"
                           formControlName="kaskoVariante">
            <div *ngFor="let kv of getKaskoVarianten() | async">
              <mat-radio-button [value]="kv">{{ kv.Value }}</mat-radio-button> <div *ngIf="showKaskoInfoTexts(kv.Key).show && showKaskoInfoTexts(kv.Key).value === 'moto'" class="label-infotext label-infotext-moto">{{ getKaskoInfoText(kv.Key) }}</div>
              <div *ngIf="showKaskoInfoTexts(kv.Key).show && showKaskoInfoTexts(kv.Key).value === 'oeamtc'" class="label-infotext">{{ getKaskoInfoText(kv.Key) }}</div>
            </div>
          </mat-radio-group>
          <mat-error *ngIf="kaskoVariante.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
        </div>
      </ng-template>
    </div>
    <div class="kfz-paket-body-extension" *ngIf="kaskoVariante.value?.Key !== null">
      <div class="paket-kasko-vehicle">
        <div>
          <div *ngIf="showFahrzeugZustand">
            <div *ngIf="complete; else _fahrzeugZustand">
              <div class="input">
                <label class="input__label" [for]="idprefix + '_fahrzeugZustand_' + kaskoIndex">Neufahrzeug:</label>
                <mat-form-field>
                  <input matInput [id]="idprefix + '_fahrzeugZustand_' + kaskoIndex" [value]="fahrzeugZustand.value | toCapLetter" disabled>
                </mat-form-field>
              </div>
            </div>
            <ng-template #_fahrzeugZustand>
              <div class="input_radio">
                <app-label [control]="fahrzeugZustand" [for]="idprefix + '_fahrzeugZustand_' + kaskoIndex">Um welches Fahrzeug handelt es sich?</app-label>
                <div class="label-infotext pb-3" [innerHTML]="(translateService.get('BESICHTIGUNGSRICHTLINIEINFO') | async)"></div>
                <mat-radio-group [id]="idprefix + '_fahrzeugZustand_' + kaskoIndex" formControlName="fahrzeugZustand">
                  <mat-radio-button value="ja">Neufahrzeug</mat-radio-button>
                  <mat-radio-button value="nein">Gebrauchtfahrzeug</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="fahrzeugZustand.hasError('required') && parentFormGroupDirective.submitted">
                  {{ 'SELECTREQUIRED' | translate }}
                </mat-error>
              </div>
            </ng-template>
          </div>
        </div>
        <div>
          <div>
            <div *ngIf="showListenpreis">
              <div *ngIf="complete; else _listenpreis">
                <div class="input">
                  <label class="input__label" [for]="idprefix + '_listenpreis_' + kaskoIndex">Listenpreis:</label>
                  <mat-form-field>
                    <input matInput [id]="idprefix + '_listenpreis_' + kaskoIndex" [value]="listenpreis.value | customCurrency: 0" disabled>
                  </mat-form-field>
                </div>
              </div>
              <ng-template #_listenpreis>
                <div class="input">
                  <div class="text_info">
                    <app-label [control]="listenpreis" class="input__label" [for]="idprefix + '_listenpreis_' + kaskoIndex">{{ expertMode ? 'Neuwert-Listenpreis (brutto)' : 'Wie hoch ist der Neuwert-Listenpreis (brutto) Ihres Fahrzeugs?' }}</app-label>
                    <div class="info">
                      <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get(expertMode ? 'LISTENPREISEXPERTINFO' : 'LISTENPREISINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
                    </div>
                  </div>
                  <mat-form-field>
                    <input matInput [id]="idprefix + '_listenpreis_' + kaskoIndex" mask="separator.0" prefix="€ " thousandSeparator="." suffix=",-" [maxlength]="14" formControlName="listenpreis">
                    <mat-error *ngIf="listenpreis.hasError('required')">{{ 'INPUTREQUIRED' | translate }}</mat-error>
                    <mat-error *ngIf="listenpreis.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
                    <mat-error *ngIf="!listenpreis.hasError('pattern') && listenpreis.hasError('min')">{{ 'MINVALUE' | translate:{'value': listenpreis.errors.min.min} }}</mat-error>
                    <mat-error *ngIf="listenpreis.hasError('sumTooHigh') && !motorrad && !expertMode">{{ 'SUMTOOHIGH' | translate }}<br></mat-error>
                    <mat-error *ngIf="listenpreis.hasError('sumTooHigh') && !motorrad && expertMode">{{ 'SUMTOOHIGHEXPERT' | translate }}<br></mat-error>
                    <mat-error *ngIf="listenpreis.hasError('sumTooHigh') && motorrad && !expertMode">{{ 'SUMTOOHIGHMOTORRAD' | translate }}<br></mat-error>
                    <mat-error *ngIf="listenpreis.hasError('sumTooHigh') && motorrad && expertMode">{{ 'SUMTOOHIGHMOTORRADEXPERT' | translate }}<br></mat-error>
                  </mat-form-field>
                  <div class="custom-select__label red-error-text-circle" *ngIf="!listenpreis.hasError('pattern') && listenpreis.hasError('max')">{{  motorrad ? ('LISTENPREISMOTORRADMAXVALUE' | translate ) : ('MAXVALUE' | translate:{'value': listenpreis.errors.max.max}) + ' '}}<span [innerHTML]="((expertMode? translateService.get('SPEZIELLEANFRAGEEXPERT')  : translateService.get('SPEZIELLEANFRAGEMOTORAD'))|async)"></span></div>
                </div>
              </ng-template>
            </div>
            <div *ngIf="showSonderausstattung">
              <div *ngIf="complete; else _sonderausstattung">
                <div class="input">
                  <label class="input__label" [for]="idprefix + '_sonderausstattung_' + kaskoIndex">Sonderausstattung:</label>
                  <mat-form-field>
                    <input matInput [id]="idprefix + '_sonderausstattung_' + kaskoIndex" [value]="sonderausstattung.value | customCurrency: 0" disabled>
                  </mat-form-field>
                </div>
              </div>
              <ng-template #_sonderausstattung>
                <div class="input">
                  <ng-template #sonderausstattungLabelTemplate>
                    <app-label [control]="sonderausstattung" class="input__label" [for]="idprefix + '_sonderausstattungDetails_' + kaskoIndex">{{ expertMode ? 'Sonderausstattung (brutto)' : 'Wie hoch ist der Wert Ihrer gesamten Sonderausstattung?' }}</app-label>
                  </ng-template>
                  <div *ngIf="motorrad && expertMode; else sonderausstattungInfoLabelTemplate">
                    <ng-template [ngTemplateOutlet]="sonderausstattungLabelTemplate"></ng-template>
                  </div>
                  <ng-template #sonderausstattungInfoLabelTemplate>
                    <div class="text_info">
                      <ng-template [ngTemplateOutlet]="sonderausstattungLabelTemplate"></ng-template>
                      <div class="info">
                        <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get(motorrad ? 'SONDERAUSSTATTUNGMOTORRADINFO' : expertMode ? 'SONDERAUSSTATTUNGKFZEXPERTINFO' : 'SONDERAUSSTATTUNGKFZINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
                      </div>
                    </div>
                  </ng-template>
                  <mat-form-field>
                    <input matInput [id]="idprefix + '_sonderausstattung_' + kaskoIndex" mask="separator.0" prefix="€ " thousandSeparator="." suffix=",-" [maxlength]="14" formControlName="sonderausstattung">
                    <mat-error *ngIf="sonderausstattung.hasError('pattern')">{{ 'INPUTINVALID' | translate }}</mat-error>
                    <mat-error *ngIf="!sonderausstattung.hasError('pattern') && sonderausstattung.hasError('min')">{{ motorrad ? ('SONDERAUSSTATTUNGMOTORRADMINVALUE' | translate) : ('SONDERAUSSTATTUNGMINVALUE' | translate) }}</mat-error>
                    <mat-error *ngIf="sonderausstattung.hasError('sumTooHigh') && !motorrad && !expertMode">{{ 'SUMTOOHIGH' | translate }}<br></mat-error>
                    <mat-error *ngIf="sonderausstattung.hasError('sumTooHigh') && !motorrad && expertMode">{{ 'SUMTOOHIGHEXPERT' | translate }}<br></mat-error>
                    <mat-error *ngIf="sonderausstattung.hasError('sumTooHigh') && motorrad && !expertMode">{{ 'SUMTOOHIGHMOTORRAD' | translate }}<br></mat-error>
                    <mat-error *ngIf="sonderausstattung.hasError('sumTooHigh') && motorrad && expertMode">{{ 'SUMTOOHIGHMOTORRADEXPERT' | translate }}<br></mat-error>
                  </mat-form-field>
                  <div class="text_info" *ngIf="!sonderausstattung.hasError('pattern') && sonderausstattung.hasError('max')">
                    <label class="custom-select__label red-error-text-circle" for="sonderausstattung">{{ motorrad ? ('SONDERAUSSTATTUNGMOTORRADMAXVALUE' | translate) : ('SONDERAUSSTATTUNGMAXVALUE' | translate) }}<span [innerHTML]="(expertMode? translateService.get('SPEZIELLEANFRAGEEXPERT')  : translateService.get('SPEZIELLEANFRAGEMOTORAD'))|async"></span></label>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <div *ngIf="showSonderausstattungDetails">
          <app-textarea [parentFormGroupDirective]="parentFormGroupDirective" [control]="sonderausstattungDetails" [id]="idprefix + '_sonderausstattungDetails_' + kaskoIndex" label="Sonderausstattung detailliert und mit Beträgen anführen:"></app-textarea>
        </div>
        <div>
          <div class="input_radio" *ngIf="showVinkulierungFahrzeug">
            <app-label [control]="vinkulierungFahrzeug" [for]="idprefix + '_vinkulierungFahrzeug_' + kaskoIndex">Vinkulierung für Fahrzeug:</app-label>
            <mat-radio-group [id]="idprefix + '_vinkulierungFahrzeug_' + kaskoIndex" formControlName="vinkulierungFahrzeug">
              <mat-radio-button value="ja">Ja</mat-radio-button>
              <mat-radio-button value="nein">Nein</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div>
          <div class="input" *ngIf="showVinkularglaeubiger">
            <app-label [control]="vinkularglaeubiger" class="input__label" [for]="idprefix + '_vinkularglaeubiger_' + kaskoIndex">Vinkulierung zu Gunsten:</app-label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_vinkularglaeubiger_' + kaskoIndex" formControlName="vinkularglaeubiger">
              <mat-error *ngIf="vinkularglaeubiger.hasError('required') && parentFormGroupDirective.submitted">{{ 'INPUTREQUIRED' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="showLeasingMotorrad">
          <div class="input_radio">
            <app-label [control]="leasingMotorrad" [for]="idprefix + '_leasingMotorrad_' + kaskoIndex">Ist Ihr Motorrad ein Leasingfahrzeug?</app-label>
            <mat-radio-group [id]="idprefix + '_leasingMotorrad_' + kaskoIndex" formControlName="leasingMotorrad">
              <mat-radio-button value="ja">Ja</mat-radio-button>
              <mat-radio-button value="nein">Nein</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="input" *ngIf="showLeasingOrt">
            <app-label [control]="leasingOrt" class="input__label" [for]="idprefix + '_leasingOrt_' + kaskoIndex">Wo haben Sie Ihr Fahrzeug geleast?</app-label>
            <mat-form-field>
              <input matInput [id]="idprefix + '_leasingOrt_' + kaskoIndex" formControlName="leasingOrt">
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="showLeasingFahrzeug">
          <div *ngIf="complete; else _leasingFahrzeug">
            <div class="input">
              <label class="input__label" [for]="idprefix + '_leasingFahrzeug_' + kaskoIndex">Leasingfahrzeug:</label>
              <mat-form-field>
                <input matInput [id]="idprefix + '_leasingFahrzeug_' + kaskoIndex" [value]="leasingFahrzeug.value | toCapLetter" disabled>
              </mat-form-field>
            </div>
          </div>
          <ng-template #_leasingFahrzeug>
            <div class="input_radio" *ngIf="showLeasingFahrzeug">
              <app-label [control]="leasingFahrzeug" [for]="idprefix + '_leasingFahrzeug_' + kaskoIndex">{{ expertMode ? 'Ist das Fahrzeug ein Leasingfahrzeug?' : 'Ist Ihr Fahrzeug ein Leasingfahrzeug?' }}</app-label>
              <mat-radio-group [id]="idprefix + '_leasingFahrzeug_' + kaskoIndex" formControlName="leasingFahrzeug">
                <mat-radio-button value="ja">Ja</mat-radio-button>
                <mat-radio-button value="nein">Nein</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="leasingFahrzeug.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
            </div>
          </ng-template>
        </div>
        <div class="kfz-paket-conditional-selection" *ngIf="showNeuwertentschaedigung">
          <div *ngIf="complete; else _neuwertentschaedigung">
            <div class="input">
              <label class="input__label" [for]="idprefix + '_neuwertentschaedigung_' + kaskoIndex">Neuwertentschädigung/KaskoPLUS:</label>
              <mat-form-field>
                <input matInput [id]="idprefix + '_neuwertentschaedigung_' + kaskoIndex" [value]="neuwertentschaedigung.value" disabled>
              </mat-form-field>
            </div>
          </div>
          <ng-template #_neuwertentschaedigung>
            <div class="input_radio">
              <div class="text_info">
                <app-label [control]="neuwertentschaedigung" [for]="idprefix + '_neuwertentschaedigung_' + kaskoIndex">
                  Möchten Sie eine Neuwertentschädigung/KaskoPLUS?
                </app-label>
                <span class="info-inline info_trigger icon--before icon--info" *ngIf="(translateService.get('NEUWERTENTSCHAEDIGUNGINFO') | async) as res" (click)="popupService.openInfoPopup(res, true, 'KaskoPLUS-Neuwertentschädigung bei Totalschaden')"></span>
              </div>
              <mat-radio-group [id]="idprefix + '_neuwertentschaedigung_' + kaskoIndex" formControlName="neuwertentschaedigung">
                <mat-radio-button value="ja">Ja</mat-radio-button>
                <mat-radio-button value="nein">Nein</mat-radio-button>
              </mat-radio-group>
              <mat-error *ngIf="neuwertentschaedigung.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
            </div>
          </ng-template>
        </div>
        <div class="kfz-paket-conditional-selection" *ngIf="showLeasingklausel">
          <div *ngIf="complete; else _leasingklausel">
            <div class="input">
              <label class="input__label" [for]="idprefix + '_leasingklausel_' + kaskoIndex">Leasingklausel:</label>
              <mat-form-field>
                <input matInput [id]="idprefix + '_leasingklausel_' + kaskoIndex" [value]="leasingklausel.value | toCapLetter" disabled>
              </mat-form-field>
            </div>
          </div>
          <ng-template #_leasingklausel>
            <div class="input_radio">
              <div class="text_info">
                <app-label [control]="leasingklausel" [for]="idprefix + '_leasingklausel_' + kaskoIndex">Leasingklausel:</app-label>
                <span class="info-inline info_trigger icon--before icon--info" *ngIf="(translateService.get('LEASINGKLAUSEL') | async) as res" (click)="popupService.openInfoPopup(res, true, 'LEASINGKLAUSEL (abschließbar für alle EU-VOLLKASKOPRODUKTE)')"></span>
              </div>
              <mat-radio-group [id]="idprefix + '_leasingklausel_' + kaskoIndex" formControlName="leasingklausel">
                <mat-radio-button value="ja" [disabled]="true">Ja</mat-radio-button>
                <mat-radio-button value="nein" [disabled]="true">Nein</mat-radio-button>
                <span class="label-infotext">Die Leasingklausel ist ab sofort prämienfrei inkludiert</span>
              </mat-radio-group>
              <mat-error *ngIf="leasingklausel.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
            </div>
          </ng-template>
        </div>
        <div *ngIf="showEVorsorgepaket">
          <div *ngIf="complete; else _evorsorgepaket">
            <div class="input">
              <label class="input__label" [for]="idprefix + '_evorsorgepaket_' + kaskoIndex" [innerHTML]="expertMode ? 'Wünscht der VN ein E-Vorsorgepaket? Die Mehrprämie liegt bei <span class=custom_currency>€ 95,-</span> (Jahresbruttoprämie).' : 'Möchten Sie gegen eine Mehrprämie von <span class=custom_currency>€ 95,-</span> (Jahresbruttoprämie) das E-Vorsorgepaket für Ihr Fahrzeug hinzufügen?'">
              </label>
              <mat-form-field>
                <input matInput [id]="idprefix + '_evorsorgepaket_' + kaskoIndex" [value]="evorsorgepaket.value | toCapLetter" disabled>
              </mat-form-field>
            </div>
          </div>
          <ng-template #_evorsorgepaket>
            <div id="zusatzpakete_e_vorsorgepaket" class="kfz-paket-sub-container-accent">
              <div class="kfz-paket-sub-header">Vorsorgepaket für Elektro- und Hybridfahrzeuge</div>
              <div class="kfz-paket-body">
                <div class="kfz-paket-description">
                  <ul>
                    <li>Wallbox (Heimladestation) bis <span class=custom_currency>€ 4.000,-</span></li>
                    <li>Ladekabel und mobile Ladestation bis <span class=custom_currency>€ 500,-</span></li>
                    <li>Schäden durch Überspannungsschäden / Tierverbisse bis max. <span class=custom_currency>€ 2.000,-</span></li>
                    <li>Bergungs- und Abschleppkosten bis max. <span class=custom_currency>€ 5.000,-</span></li>
                    <li>Akkumulator-Entsorgungskosten bis <span class=custom_currency>€ 10.000,-</span></li>
                    <li>Unfall- und andere Fahrzeugschäden durch Hackerangriffe</li>
                    <li class="smallprint-gray"><a href="https://www.hdi.at/produkte/mobilitaet/kfz-versicherung/" target="_blank" class="paket-link">Weitere Informationen</a></li>
                  </ul>
                </div>
                <div class="input_radio">
                  <app-label [control]="evorsorgepaket" [for]="idprefix + '_evorsorgepaket_' + kaskoIndex" [htmlStr]="expertMode ? 'Wünscht der VN ein E-Vorsorgepaket? Die Mehrprämie liegt bei <span class=custom_currency>€ 95,-</span> (Jahresbruttoprämie).' : 'Möchten Sie gegen eine Mehrprämie von <span class=custom_currency>€ 95,-</span> (Jahresbruttoprämie) das E-Vorsorgepaket für Ihr Fahrzeug hinzufügen?'"></app-label>
                  <mat-radio-group [id]="idprefix + '_evorsorgepaket_' + kaskoIndex" formControlName="evorsorgepaket">
                    <mat-radio-button value="ja">Ja</mat-radio-button>
                    <mat-radio-button value="nein">Nein</mat-radio-button>
                  </mat-radio-group>
                  <mat-error *ngIf="evorsorgepaket.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
        <div>
          <div *ngIf="showVorsteuerabzugsberechtigt">
            <div *ngIf="complete; else _vorsteuerabzugsberechtigt">
              <div class="input">
                <label class="input__label" [for]="idprefix + '_vorsteuerabzugsberechtigt_' + kaskoIndex">Vorsteuerabzugsberechtigt:</label>
                <mat-form-field>
                  <input matInput [id]="idprefix + '_vorsteuerabzugsberechtigt_' + kaskoIndex" [value]="vorsteuerabzugsberechtigt.value | toCapLetter" disabled>
                </mat-form-field>
              </div>
            </div>
            <ng-template #_vorsteuerabzugsberechtigt>
              <div class="input_radio">
                <div class="text_info">
                  <app-label [control]="vorsteuerabzugsberechtigt" [for]="idprefix + '_vorsteuerabzugsberechtigt_' + kaskoIndex">{{ expertMode ? 'Vorsteuerabzugsberechtigt:' : 'Liegt eine Berechtigung zum Vorsteuerabzug vor?' }}</app-label>
                  <div class="info">
                    <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('VORSTEUERABZUGSBERECHTIGTINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
                  </div>
                </div><mat-radio-group [id]="idprefix + '_vorsteuerabzugsberechtigt_' + kaskoIndex" formControlName="vorsteuerabzugsberechtigt">
                  <mat-radio-button value="ja">Ja</mat-radio-button>
                  <mat-radio-button value="nein">Nein</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="vorsteuerabzugsberechtigt.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div>
        <div>
          <div *ngIf="showBmStufeKasko">
            <div *ngIf="complete; else _bmStufeKasko">
              <div class="input">
                <label class="input__label" [for]="idprefix + '_bmStufeKasko_' + kaskoIndex">Abweichende Bonus-Malus-Stufe:</label>
                <mat-form-field>
                  <input matInput [id]="idprefix + '_bmStufeKasko_' + kaskoIndex" [value]="bmStufeKasko.value?.Value" disabled>
                </mat-form-field>
              </div>
            </div>
            <ng-template #_bmStufeKasko>
              <div class="custom_select">
                <div class="text_info">
                  <app-label [control]="bmStufeKasko" class="custom-select__label" [for]="idprefix + '_bmStufeKasko_' + kaskoIndex">Abweichende Bonus-Malus-Stufe</app-label>
                  <div class="info">
                    <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('BMSTUFEKASKOINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
                  </div>
                </div>
                <mat-form-field>
                  <mat-select [id]="idprefix + '_bmStufeKasko_' + kaskoIndex" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="bmStufeKasko" [compareWith]="lookupService.compareValues">
                    <mat-option *ngFor="let bm of bmStufenKasko | async" [value]="bm">{{ bm.Value }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="bmStufeKasko.hasError('required')">{{ 'SELECTREQUIRED' | translate }}</mat-error>
                </mat-form-field>
              </div>
            </ng-template>
          </div>
        </div>
        <div>
          <div *ngIf="!complete">
            <div class="custom_select" *ngIf="showSelbstbehaltBlock">
              <div class="input_radio">
                <app-label [control]="selbstbehaltVariante" class="custom-select__label" [for]="idprefix + '_selbstbehaltVariante_' + kaskoIndex">Welche Selbstbehaltvariante passt für Sie?</app-label>
                <mat-radio-group [id]="idprefix + '_selbstbehaltVariante_' + kaskoIndex" [placeholder]="translateService.get('SELECTPLACEHOLDER') | async" formControlName="selbstbehaltVariante">
                  <mat-radio-button *ngFor="let sv of selbstbehaltVarianten | async" [value]="sv">{{ sv.Value }}</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="selbstbehaltVariante.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
              </div>
              <div *ngIf="showErhoehungSelbstbehalt">
                <div class="smallprint-gray paket-inline-tipp" *ngIf="showErhoehungSelbstbehaltHint">
                  Bei Sch&auml;den an Blinkercellonen, Heckleuchten, Scheinwerfern und Spiegelglas beträgt die Selbstbeteiligung <span class=custom_currency>€ 150,-</span>. Bei Reparatur in einer unserer Partnerwerkst&auml;tten bezahlen Sie nur den halben Selbstbehalt.
                  Eine vollst&auml;ndige 	&Uuml;bersicht der Selbstbehalte finden Sie in der <a [attr.href]="showVollkaskoHint ? 'https://www.hdi.at/downloads/formulare/deckungsumfang_kfz_vollkasko_ab_25.4.2022.pdf' : 'https://www.hdi.at/downloads/formulare/deckungsumfang_kfz_teilkasko_ab_25.4.2022.pdf'" target="_blank" class="paket-link">DECKUNGS&Uuml;BERSICHT.</a>
                </div>
                <div class="input_radio">
                  <app-label [control]="erhoehungSelbstbehalt" [for]="idprefix + '_erhoehungSelbstbehalt_' + kaskoIndex">Welche Selbstbehalthöhe wünschen Sie?</app-label>
                  <mat-radio-group [id]="idprefix + '_erhoehungSelbstbehalt_' + kaskoIndex" formControlName="erhoehungSelbstbehalt">
                      <mat-radio-button value="ja">maximal <span class=custom_currency>{{ (selbstbehalthoehen | async)?.[1].toString() | customCurrency:0 }}</span></mat-radio-button>
                      <mat-radio-button value="nein">maximal <span class=custom_currency>{{ (selbstbehalthoehen | async)?.[0].toString()  | customCurrency:0 }}</span></mat-radio-button>
                  </mat-radio-group>
                  <mat-error *ngIf="erhoehungSelbstbehalt.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div *ngIf="complete && !motorrad && interesseKaskoversicherung">
            <div class="input">
              <label class="input__label" [for]="idprefix + '_selbstbehaltHoehe_' + kaskoIndex">Selbstbehalt:</label>
                <mat-form-field>
                <input matInput [id]="idprefix + '_selbstbehaltHoehe_' + kaskoIndex" [value]="(kaskoKfzComponent?.selbstbehalthoehe | async)?.toString() | customCurrency:0" disabled>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      <div>
        <div *ngIf="showFooter" class="kaskoFooter"></div>
      </div>
    </div>
  </div>
</form>
